import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface CategoryHeroProps {
  categoryName: string;
}

export default function CategoryHero({ categoryName }: CategoryHeroProps) {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[300px] md:h-[420px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20anime%20style%20landscape%20with%20warm%20pink%20cherry%20blossom%20petals%20drifting%20across%20a%20golden%20sunset%20sky%2C%20distant%20city%20silhouette%2C%20dreamy%20cinematic%20atmosphere%2C%20warm%20coral%20and%20amber%20tones%2C%20clean%20and%20simple%20composition%2C%20high%20quality%20anime%20background%20art&width=1920&height=840&seq=category-hero-bg&orientation=landscape"
        alt={`${categoryName} - 樱花动漫分类`}
        title={`${categoryName}动漫 - 樱花动漫`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="font-heading text-3xl md:text-5xl text-white leading-tight mb-3">
          {categoryName}
        </h1>
        <p className="text-sm md:text-base text-white/70">
          {t('海量动漫资源高清流畅播放')}
        </p>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pb-4 md:pb-6 text-center z-10">
        <p className="font-heading text-2xl md:text-4xl text-white/20 font-bold tracking-wider select-none">
          {categoryName} ANIME
        </p>
      </div>
    </section>
  );
}